import { render } from "./BuildingKitAiTestingNew.vue?vue&type=template&id=25f4a3ec&scoped=true&lang=pug"
import script from "./BuildingKitAiTestingNew.vue?vue&type=script&lang=js"
export * from "./BuildingKitAiTestingNew.vue?vue&type=script&lang=js"

import "./BuildingKitAiTestingNew.vue?vue&type=style&index=0&id=25f4a3ec&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25f4a3ec"]])

export default __exports__